var _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGyro(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 268,
    height: 214,
    viewBox: "0 0 268 214",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "petshade",
    d: "M232.626 181.952C232.793 188.851 192.218 199.526 136.825 199.57C65.549 202.133 35.4647 190.913 35.2969 184.014C35.1291 177.114 71.8331 169.552 139.713 169.497C204.337 169.445 232.458 175.053 232.626 181.952Z",
    fill: "#1792B9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "pet",
    d: "M46.9808 90H219.703V202H46.9808V90Z",
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0",
    transform: "translate(0 -0.0137029) scale(0.0013624 0.00210103)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 734,
    height: 489,
    xlinkHref: "/klokhuisscanner/pictures/beerdiertje.png"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGyro);
export default __webpack_public_path__ + "static/media/gyro.d254fba7.svg";
export { ForwardRef as ReactComponent };